/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Party_Label_ChildrenInputs */

const en_party_label_children = /** @type {(inputs: Party_Label_ChildrenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} children`)
};

/**
* | output |
* | --- |
* | "{count} children" |
*
* @param {Party_Label_ChildrenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const party_label_children = /** @type {((inputs: Party_Label_ChildrenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Party_Label_ChildrenInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_party_label_children(inputs)
});